<div [formGroup]="form">
  <mat-form-field 
    id="listPrinter"
    [ngClass]="{ 'col-12 col-md-12': column }"
    class="col-6 col-md-4"
    *ngIf="isGuideEditable"
    >
    <mat-label>Seleccionar impresora</mat-label>
    <mat-select
      formControlName="inputPrinter"
      id="printer"      
      required
    >
      <mat-option
        *ngFor="let option of listPrinters"
        [value]="option"
        [id]="option"
      >
        <span>{{ option }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
   <mat-form-field 
    [ngClass]="{ 'col-12 col-md-12': column }"
    class="col-6 col-md-4"
    *ngIf="!isGuideEditable"
    >
    <mat-label>Nro de serie *</mat-label>
    <input
      matInput
      id="serialNumber"
      name="serialNumber"
      formControlName="serialNumber"  
      autocomplete="off"
      [readonly]="true"
      >
  </mat-form-field> 
  <mat-form-field
    [ngClass]="{ 'col-12 col-md-12': column }"
    class="col-6 col-md-4">
    <mat-label>Correlativo</mat-label>
    <input
      matInput
      id="dispatchCode"
      name="dispatchCode"
      formControlName="codeGuia"
      autocomplete="off"
      [readonly]="!isGuideEditable && !isGRI"
      class="input-correlativo"
    />
    <mat-hint
      *ngIf="form.get('codeGuia').invalid && form.get('codeGuia').hasError && (form.get('codeGuia').dirty || form.get('codeGuia').touched)"
    >
      <mat-error *ngIf="form.get('codeGuia').errors['minlength']">
        Mínimo 7 dígitos
      </mat-error>
      <mat-error *ngIf="form.get('codeGuia').errors['maxlength']">
        Máximo 7 dígitos
      </mat-error>
      <mat-error *ngIf="form.get('codeGuia').errors['required']">
        Campo obligatorio
      </mat-error>
      <mat-error *ngIf="form.get('codeGuia').errors['pattern']">
        Caracter inválido
      </mat-error>
    </mat-hint>
    <!-- <mat-hint *ngIf="form.controls.codeGuia.valid && !(form.value.codeGuia && codeGuiaCurrent > form.value.codeGuia)"> -->
    <mat-hint *ngIf="form.controls['codeGuia'].valid">
      ¿El Nro. <strong>{{ codeGuiaCurrent }}</strong> coincide con las guías?</mat-hint
    >
    <!-- <mat-hint class="text-danger" *ngIf="form.controls.codeGuia.valid && (form.value.codeGuia && codeGuiaCurrent > form.value.codeGuia)">
      Guía ya impresa</mat-hint
    > -->
    <mat-icon
      matSuffix
      class="icon-primary"
      tooltip="actualizar"
      *ngIf="
        form.value.codeGuia &&
        codeGuiaCurrent !== form.value.codeGuia
      "
      >warning</mat-icon
    >
  </mat-form-field>
</div>
